export default __webpack_public_path__ + "static/media/seo_academy_bubble.d10083fb.svg";